import { AdminDashboard } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

/**
 * Generates an array of route objects for the admin dashboard.
 * @returns {Array} An array containing the route object for the admin dashboard.
 */
export default function route() {
  return [
    {
      path: adminRouteMap.DASHBOARD.path,  // URL path for the dashboard
      name: "Dashboard",  // Display name for the route
      key: adminRouteMap.DASHBOARD.path,  // Unique key for the route
      private: true,  // Requires authentication to access
      belongsToSidebar: true,  // Appears in the admin sidebar
      icon: adminRouteMap.DASHBOARD.icon,  // Icon associated with the dashboard
      element: <AdminDashboard />,  // Component to render for this route
    },
  ];
}
